<section class="calculator-section" id="calculator">
  <div class="calculator-container">
    <div class="calculator-header">
      <h2>Estimate Your Bill</h2>
      <p>See how affordable growing your mission can be with our transparent, pay-as-you-grow pricing.</p>
    </div>

    <div class="calculator-grid">
      <!-- Interactive Inputs -->
      <div class="calculator-controls">
        
        <div class="control-group">
          <label>Stationary Kiosks</label>
          <div class="slider-container">
            <input type="range" min="0" max="10" [(ngModel)]="kiosks" class="slider">
            <span class="value-display">{{ kiosks }}</span>
          </div>
        </div>

        <div class="control-group">
          <label>Mobile Boxes (DonationBoxes)</label>
          <div class="slider-container">
            <input type="range" min="0" max="10" [(ngModel)]="mobileBoxes" class="slider">
            <span class="value-display">{{ mobileBoxes }}</span>
          </div>
        </div>

        <div class="control-group">
          <label>
            Non-Digital Donations / mo 
            <mat-icon matTooltip="Cash, check, or Zelle records" class="info-icon">info</mat-icon>
          </label>
          <div class="slider-container">
            <input type="range" min="0" max="1000" step="50" [(ngModel)]="offlineDonations" class="slider">
            <span class="value-display">{{ offlineDonations }}</span>
          </div>
          <small class="hint-text">First 200 are free, then $0.10/record</small>
        </div>

        <div class="control-group">
          <label>
            Communications / mo
            <mat-icon matTooltip="Broadcasts, reminders, re-sends, tax documents. First donation receipt is always free." class="info-icon">info</mat-icon>
          </label>
          <div class="slider-container">
            <input type="range" min="0" max="5000" step="100" [(ngModel)]="communications" class="slider">
            <span class="value-display">{{ communications | number }}</span>
          </div>
          <small class="hint-text">First 200 are free, then $0.005/email</small>
        </div>

        <div class="checkbox-group">
          <label class="custom-checkbox">
            <input type="checkbox" [(ngModel)]="needSim">
            <span>Include Cellular SIMs ($10/mo per device)</span>
          </label>
        </div>

        <div class="checkbox-group">
          <label class="custom-checkbox">
            <input type="checkbox" [(ngModel)]="needSetup">
            <span>Add On-Site Setup ($100 one-time fee)</span>
          </label>
        </div>
      </div>

      <!-- Bill Summary Receipt -->
      <div class="calculator-summary">
        <div class="bill-card">
          <div class="bill-card-content">
            <h2 class="bill-card-title">Estimated Bill</h2>
            
            <!-- Upfront Costs -->
            <div class="bill-section">
              <h3>Upfront Costs</h3>
              <div class="bill-row" *ngIf="totalDevices > 0">
                <span class="item-name">First Device (Intro Offer)</span>
                <span class="item-cost">$399.00</span>
              </div>
              <div class="bill-row" *ngIf="totalDevices > 1">
                <span class="item-name">Additional Devices ({{ totalDevices - 1 }})</span>
                <span class="item-cost">{{ ((totalDevices - 1) * 299) | currency }}</span>
              </div>
              <div class="bill-row" *ngIf="needSetup">
                <span class="item-name">On-Site Setup</span>
                <span class="item-cost">$100.00</span>
              </div>
              <mat-divider></mat-divider>
              <div class="bill-row total-row">
                <strong>Total Upfront</strong>
                <strong>{{ totalUpfront | currency }}</strong>
              </div>
            </div>

            <!-- Monthly Costs -->
            <div class="bill-section">
              <h3>Monthly Costs</h3>
              
              <div class="bill-row">
                <span class="item-name">Platform Base Fee</span>
                <span class="item-cost">$0.00</span>
              </div>

              <div class="bill-row">
                <span class="item-name">Offline Records ({{ offlineDonations }})</span>
                <span class="item-cost">{{ monthlyOffline === 0 ? 'Free' : (monthlyOffline | currency) }}</span>
              </div>

              <div class="bill-row">
                <span class="item-name">Communications ({{ communications | number }})</span>
                <span class="item-cost">{{ monthlyComms === 0 ? 'Free' : (monthlyComms | currency) }}</span>
              </div>

              <div class="bill-row" *ngIf="needSim && totalDevices > 0">
                <span class="item-name">SIM Connectivity ({{ totalDevices }})</span>
                <span class="item-cost">{{ monthlySim | currency }}</span>
              </div>

              <mat-divider></mat-divider>
              <div class="bill-row total-row blue-highlight">
                <strong>Total Monthly</strong>
                <strong>{{ totalMonthly | currency }} / mo</strong>
              </div>
            </div>

            <div class="bill-note">
              <p>Digital donations incur Stripe fees + 0.5% + 10¢ per transaction as shown in pricing.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>